import { useEffect, useState } from "react";
import "./style.scss";
import { PATH_LIST } from "shared/lib/react-router";
import Button from "shared/ui/button";
import DocumentRow from "../components/document-row";
import { useStore } from "zustand";
import { useTranslation } from "react-i18next";
import { accountStore, KYB_Step } from "entities/account";
import Loading from "widgets/loading";
import { getMLValue } from "helpers/functions";
import { firebaseLogEvent } from "app/libs/firebase";
import {
  fbLogEventOnce,
  FB_EVENTS,
  requestAdvertiserTrackingAfterVerification,
} from "utils/fbEvents";
import { sessionStore } from "entities/session/model/sessionModel";
import { useVerificationStep } from "hooks/useVerificationStep";
import { VerificationBtn } from "../components/button";

export const BusinessDocumentsPage = () => {
  const { kyb } = useStore(accountStore);
  const [isValid, setIsValid] = useState(false);
  const { t: a } = useTranslation("app");
  const { t: o } = useTranslation("app");
  const { i18n, t } = useTranslation("onboarding-auth");
  const [addressValue, setAddressValue] = useState("");
  const { isLoading, onSubmit } = useVerificationStep<KYB_Step.Documents>({
    step: KYB_Step.Documents,
    navigateOnSuccess: PATH_LIST.account,
    navigateParams: {
      state: { verificationRequestModal: true },
    },
    onSuccess: async () => {
      firebaseLogEvent("kyc_submitted");
      const userId = sessionStore.getState().user?.id;
      void fbLogEventOnce(`kyc_submit_${userId}`, FB_EVENTS.submitApplication);
      await requestAdvertiserTrackingAfterVerification();
    },
  });

  useEffect(() => {
    const documents = kyb?.documents;

    if (!documents) return;
    for (const [key, value] of Object.entries(documents)) {
      // @ts-ignore
      const isOptional = value.is_optional;
      if (isOptional) continue;

      if (!value) {
        setIsValid(false);
        return;
      }
    }
    if (!addressValue) {
      setIsValid(false);
      return;
    }

    setIsValid(true);
  }, [kyb, addressValue]);

  if (isLoading) {
    return <Loading />;
  }

  return (
    <div className="sign-business-contract">
      <h1>{t("signContract")}</h1>

      <div className="warnings">
        <ul>
          <li>{a("documentsUpToDate")}</li>
          <li>{t("maxFileSizeIs21mb")}</li>
        </ul>
      </div>

      <div className="documents">
        {Object.entries(kyb?.documents || {}).map(([key, o]: any, i) => (
          <DocumentRow
            key={key}
            file={o.is_multiple ? o.file || [] : o.file || ""}
            index={i + 1}
            text={getMLValue(o.text, i18n.language)}
            isMultiple={o.is_multiple}
            isOptional={o.is_optional}
            type={key}
          />
        ))}

        <div className="personal-address-row">
          <p>
            <span>{Object.entries(kyb?.documents || {}).length + 1}.</span>{" "}
            {t("enterCompanyAddress")}
          </p>

          <input
            className="business-doc-last-input"
            type="text"
            onChange={(e) => {
              setAddressValue(e.target.value);
            }}
            placeholder={t("enterCompanyAddress")}
          />
        </div>

        <div className="confirmCorrectness">
          <VerificationBtn
            onClick={() => {
              onSubmit({
                company_address: addressValue,
              });
            }}
            disabled={!isValid || isLoading}
            text={t("continue")}
          />
        </div>
      </div>
    </div>
  );
};
